export default "__VITE_ASSET__Q1IWGSpz__"